import { render, staticRenderFns } from "./FeedPage.vue?vue&type=template&id=745a1d3a&scoped=true&"
import script from "./FeedPage.vue?vue&type=script&lang=js&"
export * from "./FeedPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedPage.vue?vue&type=style&index=0&id=745a1d3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a1d3a",
  null
  
)

export default component.exports